import { registerReactInstance as register, IntlProvider as _IntlProvider } from "@ies/intl-react-plugin";
const registerReactInstance = function() {
  register.name = "react-plugin";
  return register;
}();
const IntlProvider = _IntlProvider;
import { I18nContext, Trans, useTranslation, withTranslation, getHtml } from "@ies/intl-react-plugin";
export {
  I18nContext,
  IntlProvider,
  Trans,
  getHtml,
  registerReactInstance,
  useTranslation,
  withTranslation
};

//# sourceMappingURL=react.js.map